import * as TopArticles from '../top-articles'
import * as Constants from './constants'

export const reducer = TopArticles.topArticlesReducer(
  Constants.FETCH_TOP_PROMOTIONS,
  Constants.TOP_PROMOTIONS_FILTER,
  Constants.FETCH_TOP_PROMOTION_SENDS,
  Constants.FETCH_TOP_PROMOTION_DETAILS)



// WEBPACK FOOTER //
// ./src/pages/reports/promotions/reducer.ts